import React, { useEffect, useState } from 'react';
import { InputGroup, Form, FormControl, Table, Pagination, Button } from 'react-bootstrap';
import { PlusIcon, SearchIcon } from '../../components/Icons';
import Loader from '../../components/Loader';
import API from '../../API';
import { ROOT, USER_PROFILE } from '../../constants/routes';
import Avatar from '../../components/Avatar';
import UserInfoModal from './UserInfoModal';
import { Link } from 'react-router-dom';

const Dashboard = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState('all');
  const [lastPage, setLastPage] = useState(1);
  const [activeUser, setActiveUser] = useState(null);
  useEffect(() => {
    fetchUsers(1);
  }, []);
  const fetchUsers = (page = 1, params = {}) => {
    setIsLoading(true);
    API.get('user/explore', { page, ...params })
      .then(resp => {
        setUsers(resp.data);
        setPage(resp.current_page);
        setLastPage(resp.last_page);
        setIsLoading(false);
      })
      .catch(errors => {
        console.log('admin user fetch error', errors);
        setIsLoading(false);
      });
  };
  const handleSearch = e => {
    let params = {};
    if (search) params.search_string = search;
    if (status && status !== 'all') params.verified_status = status;
    e.preventDefault();
    fetchUsers(1, params);
  };
  return (
    <div className="p-1">
      <h3>User List</h3>
      <hr />
      <Form inline onSubmit={handleSearch} className="mb-2 justify-content-end">
        <Form.Label className="my-1 mr-2" htmlFor="inlineFormCustomSelectPref">
          Verified status
        </Form.Label>
        <Form.Control
          as="select"
          value={status}
          onChange={e => {
            setStatus(e.target.value);
          }}
          className="my-1 mr-sm-2"
          custom
        >
          <option value="all">All</option>
          <option value="pending">Pending</option>
          <option value="verified">Verified</option>
        </Form.Control>
        <InputGroup className="mr-sm-2">
          <InputGroup.Prepend>
            <InputGroup.Text>
              <SearchIcon width={16} style={{ margin: '0px 0.75rem' }} className="cursor-pointer" />
            </InputGroup.Text>
          </InputGroup.Prepend>
          <FormControl
            placeholder="name/email/nickname"
            value={search}
            onChange={e => {
              setSearch(e.target.value);
            }}
          />
        </InputGroup>
        <Button type="submit" className="my-1">
          Search
        </Button>
      </Form>
      <Loader isLoadin={isLoading} height={36} size={28}>
        <Table striped bordered hover size="sm" responsive>
          <thead>
            <tr>
              <th width="50" className="text-center">
                ID
              </th>
              <th>Name</th>
              <th>E-mail</th>
              <th>Verified</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {!!users &&
              users.map(user => (
                <tr key={user.id}>
                  <td className="text-center">{user.id}</td>
                  <td>
                    <div className="d-flex align-items-center cursor-pointer" onClick={() => setActiveUser(user)}>
                      <Avatar size={30} image={user.avatar} className="mr-2" />
                      {user.name} <span className="text-gray">{user.nickname ? '@' + user.nickname : ''}</span>
                    </div>
                  </td>
                  <td>{user.email}</td>
                  <td>
                    {user.verified === 0 ? (
                      <span className="text-warning">Pending</span>
                    ) : user.verified === 1 ? (
                      <span className="text-success">Verified</span>
                    ) : (
                      'none'
                    )}
                  </td>
                  <td>
                    <Link
                      className="d-flex align-items-center"
                      to={USER_PROFILE.replace(':userId?', user.id).replace(
                        ':name?',
                        !!user.nickname ? user.nickname : ''
                      )}
                      target="_blank"
                    >
                      Profile
                    </Link>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
        {lastPage > 1 && (
          <Pagination className="d-flex justify-content-center">
            <Pagination.First disabled={page === 1} onClick={() => fetchUsers(1)} />
            <Pagination.Prev disabled={page === 1} onClick={() => fetchUsers(page - 1)} />
            <Pagination.Item active>{page}</Pagination.Item>
            <Pagination.Next disabled={page === lastPage} onClick={() => fetchUsers(page + 1)} />
            <Pagination.Last disabled={page === lastPage} onClick={() => fetchUsers(lastPage)} />
          </Pagination>
        )}
      </Loader>
      <UserInfoModal
        user={activeUser}
        handleClose={user => {
          if (user) {
            setUsers(users.map(el => (el.id === user.id ? user : el)));
          }
          setActiveUser(null);
        }}
      />
    </div>
  );
};

export default Dashboard;
